import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/monedas`;

export const getMonedas = async (token) => {
    const response = await fetch(API_URL, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar monedas');
    return response.json();
};

export const getMonedasPaginadas = async (token, page = 0, size = 10, search = '') => {
    const response = await fetch(`${API_URL}/page?page=${page}&size=${size}&search=${search}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar monedas paginadas');
    return response.json();
};

export const getMonedaById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al obtener la moneda');
    return response.json();
};

export const createMoneda = async (token, data) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear moneda');
    return response.json();
};

export const updateMoneda = async (token, id, data) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar moneda');
    return response.json();
};

export const deleteMoneda = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar moneda');
    return true;
};
